import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { Commission } from 'types/embedded/commission';

type Props = {
  record?: Commission;
  open: boolean;
  onClose: () => void;
};

export const MerchantCommissionsDeleteDialog = ({ onClose, open, record }: Props) => {
  const translate = useTypedTranslate();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [Resources.Commissions] });
    onClose();
  };

  return (
    <DeleteDialog
      details={translate('app.merchantCommissions.feeWillBeDeleted', { name: record?.name })}
      onClose={onClose}
      onSuccess={onSuccess}
      open={open}
      record={record}
      title={translate('app.merchantCommissions.feeDeletion')}
    />
  );
};
